export default {
    title: 'Components/BdButton',
    component: 'bd-button',
  };
  
  const Template = ({ type, disabled, href, slot }) => `
    <bd-button type="${type}" href=${href} disabled="${disabled}">${slot}</bd-button>
  `;
  
export const Primary = Template.bind({});
Primary.args = {
    type: 'button',
    disabled: false,
    href: '#',
    slot: 'Primary Button',
};
  
export const Disabled = Template.bind({});
Disabled.args = {
    type: 'button',
    disabled: true,
    href: '#',
    slot: 'Disabled Button',
};